<template>
  <div class="pnf">
    <div class="pnf__logo-wrapper">
      <img class="pnf__logo" src="@/assets/kaspi-logo.svg" />
    </div>
    <div class="pnf__title">{{ $t`Страница не найдена` }}</div>
    <div class="pnf__text">
      {{
        $t`Попробуйте вернуться на предыдущую страницу или начать все сначала.`
      }}
    </div>
    <div class="pnf__button">
      <CommonButton @click="onReturnClick">
        {{ $t`Главная страница` }}
      </CommonButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pnf {
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  font-family: Roboto-Regular;

  &__title {
    font-size: 25px;
    color: #4a4a4a;
    font-weight: 400;
    line-height: 1.2;
    margin-top: 20px;
  }

  &__text {
    font-size: 14px;
    padding: 0 15px;
    line-height: 1.2;
    color: #a8a8a8;
    margin-top: 20px;
  }

  &__button {
    margin-top: 30px;
  }

  &__logo-wrapper {
    padding-top: 30px;
  }
  &__logo {
    width: 96px;
    height: 98px;
  }
}
</style>

<script>
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  name: "PageNotFound",
  components: {
    CommonButton,
  },
  mounted() {
    this.$store.dispatch("system/setHeaderTitle", this.$route.meta.title);
  },
  methods: {
    onReturnClick() {
      window.location.href = `${process.env.VUE_APP_ENV_URL}/`;
    },
  },
};
</script>
